var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHittase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 129.9 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_3",
    x1: -24.28,
    y1: 651.06,
    x2: -24.28,
    y2: 521.06,
    gradientTransform: "translate(89.24 -521.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d63f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2898d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aecdec"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hitta.se") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M125,0a4.91,4.91,0,0,1,4.9,4.9V62.38c.1,17.39-5.6,35.19-19,48.58A65,65,0,1,1,63.63,0Z",
    transform: "translate(0)",
    style: {
      fill: "url(#Namnl\xF6s_\xF6vertoning_3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.62,43.91a7.94,7.94,0,0,0-7.2,4h-.1v-13h-7V69.7h7V55.4c0-3.4,1.8-5.9,4.6-5.9,2.2,0,4.4,1.2,4.4,4.8V69.6h7.1v-17C43.42,47.8,40.72,43.91,34.62,43.91Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.92,
    y: 44.61,
    width: 7.1,
    height: 25.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.42,43.31a4.2,4.2,0,1,0-4.2-4.2A4.29,4.29,0,0,0,50.42,43.31Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.41,70a19.52,19.52,0,0,0,3.4-.3V64.2a5.72,5.72,0,0,1-1.4.1c-1.8,0-2.3-.5-2.3-1.7V50h7.2V63.5c0,5.4,2.8,6.6,7.4,6.6a19.52,19.52,0,0,0,3.4-.3V64.3a5.72,5.72,0,0,1-1.4.1c-1.8,0-2.3-.5-2.3-1.7V50h3.7v-5.4H81.3v-9.7h-7v9.6h-7.2v-9.6H60v9.6h-3.2v5.4H60V63.4C60,68.9,62.81,70,67.41,70Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8,55c-9.9.6-10.7,5-10.7,7.7,0,5.7,4.9,7.7,8.8,7.7a10.33,10.33,0,0,0,8.6-4h.1v3.3h6.8a13.54,13.54,0,0,1-.3-3.1V52c0-5.8-5.2-8.1-11.4-8.1-8.8,0-11.6,4.9-11.8,8.8h6.8c.1-2.3,1.9-3.7,4.8-3.7,3.1,0,4.9,1.5,4.9,4.5v1.2Zm6.5,6.1c0,3-3.6,4.3-5.8,4.3-2.4,0-4.4-.7-4.4-2.9,0-1.8,1.1-2.8,4.3-3.1l5.9-.5Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.14,91.12a4.1,4.1,0,1,0,4.1,4.1A4.05,4.05,0,0,0,57.14,91.12Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.92,81.07c0-1.43,1.81-2.19,3.52-2.19,2.57,0,4,1.24,4.09,3.23l6.75-.1c-.38-5.23-4.47-7.89-10.55-7.89-7,0-9.89,4-9.89,7.7,0,9.89,14.35,6.27,14.35,10.27,0,2-2.28,2.47-4,2.47-2,0-4.09-1-4.18-3.23H63.27c.57,7,7.22,8.08,10.65,8.08,9.89,0,10.93-6.18,10.93-8C84.85,81.64,69.92,85.35,69.92,81.07Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.91,74.13c-7.22,0-12.26,4.94-12.26,12.64s5,12.55,12.26,12.55c5.61,0,10-2.57,11.69-7.41L104,91.43a5.13,5.13,0,0,1-4.75,2.85c-3.61,0-5.32-2.76-5.61-5.61h17.49v-1.9C111.18,79,106.14,74.13,98.91,74.13ZM93.59,84.3c.38-2.66,2.09-5.13,5.61-5.13,3.23,0,4.94,2.76,5.23,5.13Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHittase);
export default __webpack_public_path__ + "static/media/hittase.e5160344ec7d6ac0bdbb8beb7f716a58.svg";
export { ForwardRef as ReactComponent };